import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StoreManager } from '../../../core';
import { IStoreForShopingListItem, IStoreManagerAccountListItem } from '../../models';
import { StoreManagerService } from '../../storeManager.service';

class StoreManagerAccountComponent implements ng.IController {
    public static $inject = ['$scope', '$timeout', 'storeManagerService', 'notificationService', 'definitionsService', '$translate'];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public resolve: {
        staff: IStoreManagerAccountListItem,
        places: IStoreForShopingListItem[]
    };
    public waiting: boolean;

    public data = {
        title: this.$translate.instant('store_manager_account'),
        textBtn: '',
        showPassword: false,
        isPasswordExist: false,
        isEditStaff: false,
        password: '••••••••••••',
        places: null as IStoreForShopingListItem[],
        staffEmail: '',
        model: null as StoreManager,
        staffID: null as number,
        error: {
            firstName: null as string,
            lastName: null as string,
            email: null as string,
            password: null as string,
            places: null as string,
            clean: () => {
                const i = this.data.error;
                i.firstName = null;
                i.lastName = null;
                i.email = null;
                i.password = null;
                i.places = null;
            },
            isEmpty: () => {
                const i = this.data.error;
                return _.isEmpty(i.firstName) && _.isEmpty(i.lastName) &&
                    _.isEmpty(i.email) && _.isEmpty(i.password) &&
                    _.isEmpty(i.places);
            }
        },
        isValidModel: () => {
            const i = this.data;
            const required = this.$translate.instant('required_field');
            const staff = i.model;
            const error = i.error;
            error.clean();
            // first name
            staff.FirstName = this.trim(staff.FirstName);
            let size = _.size(staff.FirstName);
            if (size === 0) {
                error.firstName = required;
            } else if (size < 3) {
                error.firstName = this.$translate.instant('first_name_too_short');
            } else if (size > 20) {
                error.firstName = this.$translate.instant('first_name_too_long');
            }
            // last name
            staff.LastName = this.trim(staff.LastName);
            size = _.size(staff.LastName);
            if (size === 0) {
                error.lastName = required;
            } else if (size < 3) {
                error.lastName = this.$translate.instant('last_name_too_short');
            } else if (size > 20) {
                error.lastName = this.$translate.instant('last_name_too_long');
            }
            // email
            staff.Email = this.trim(staff.Email);
            size = _.size(staff.Email);
            if (size === 0) {
                error.email = required;
            } else if (size > 100) {
                error.email = this.$translate.instant('email_too_long_100');
            } else if (!this.definitionService.regexEmail.test(staff.Email)) {
                error.email = this.$translate.instant('email_is_invalid');
            }
            // password
            staff.Password = this.trim(staff.Password);
            size = _.size(staff.Password);
            if (!i.isEditStaff && size === 0) {
                error.password = required;
            } else if (size > 0 && size < 8) {
                error.password = this.$translate.instant('password_too_short_8');
            } else if (size > 20) {
                error.password = this.$translate.instant('password_too_long_20');
            }
            return error.isEmpty();
        }
    };

    constructor(
        private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        private storeManagerService: StoreManagerService,
        private notificationService: NotificationService,
        private definitionService: DefinitionsService,
        private $translate: angular.translate.ITranslateService
    ) {
    }

    public async $onInit() {
        await this.init();
    }

    public async init() {
        this.data.textBtn = this.$translate.instant(this.resolve.staff ? 'button_save' : 'button_create');
        this.data.isPasswordExist = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
        this.data.isEditStaff = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
        this.data.places = this.resolve.places ? _.filter(_.map(this.resolve.places, (place) => {
            place.selected = this.resolve.staff ? _.contains(this.resolve.staff.PlacesID, place.ID) : false;
            return place;
        }), (place) => {
            return place.selected || place.IsActive;
        }) : [];
        this.data.staffEmail = this.resolve.staff ? this.resolve.staff.Email : '';
        this.data.model = {
            FirstName: this.resolve.staff ? this.resolve.staff.FirstName : '',
            LastName: this.resolve.staff ? this.resolve.staff.LastName : '',
            Email: this.resolve.staff ? this.resolve.staff.Email : '',
            Password: '',
            PlacesID: this.resolve.staff ? this.resolve.staff.PlacesID : [],
        };
        this.data.staffID = this.resolve.staff ? this.resolve.staff.ID : null;

        this.$scope.$watch('$ctrl.data.model.Email', async (n: string, o: string) => {
            if (n && n !== o && n.trim().toLowerCase() !== this.data.staffEmail.toLowerCase() && this.definitionService.regexEmail.test(this.data.model.Email)) {
                try {
                    const exist = await this.storeManagerService.managerAccountEmailExist(n);

                    if (exist) {
                        this.data.error.email = this.$translate.instant('email_is_in_use');
                    } else {
                        this.data.error.email = null;
                    }

                } catch (error) {
                    this.notificationService.showErrorMessage(error);
                }

            }
        });

        await this.$timeout(0);
        $('.manager-stores__wrap').slimScroll({
            height: 'auto',
            alwaysVisible: true
        });
    }

    public changePlaces() {
        this.data.model.PlacesID = _.pluck(_.where(this.data.places, { selected: true }), 'ID');
    }

    public async save() {
        if (!this.data.isValidModel()) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await (this.data.isEditStaff
                ? this.storeManagerService.updateStaff(this.data.staffID, this.data.model)
                : this.storeManagerService.createStaff(this.data.model));

            this.notificationService.showSuccessMessage();
            this.modalInstance.close({ $value: true });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public close() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    private trim(str: string) {
        return str ? str.trim() : '';
    }
}

angular.module('naut').component('storeManagerAccount', {
    template: require('./storeManagerAccount.html'),
    controller: StoreManagerAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/store-managers/components/storeManagerAccount/storeManagerAccount.component.ts